import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import { API, useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";

/**
 * Toggle button for adding/removing an auction from the user's watchlist.
 * If user is not logged in, redirects to login on click.
 */
export default function WatchlistButton({ auctionId, className = "", variant = "icon" }) {
  const { user } = useAuth();
  const { t } = useLanguage();
  const [inList, setInList] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!auctionId || !user || user === false) return;
    axios.get(`${API}/watchlist/status/${auctionId}`).then(r => setInList(!!r.data.in_watchlist)).catch(() => {});
  }, [auctionId, user]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user || user === false) { window.location.href = "/login"; return; }
    setBusy(true);
    try {
      if (inList) {
        await axios.delete(`${API}/watchlist/${auctionId}`);
        setInList(false);
        toast.success(t("Rimosso dai preferiti"));
      } else {
        await axios.post(`${API}/watchlist/${auctionId}`);
        setInList(true);
        toast.success(t("Aggiunto ai preferiti"));
      }
    } catch (err) {
      toast.error(t("Errore"));
    } finally { setBusy(false); }
  };

  if (variant === "icon") {
    return (
      <button
        onClick={toggle}
        data-testid={`watchlist-toggle-${auctionId}`}
        disabled={busy}
        aria-label={inList ? t("Rimuovi dai preferiti") : t("Aggiungi ai preferiti")}
        className={`p-2 bg-stone-50/80 backdrop-blur-sm border border-stone-200 hover:bg-stone-50 transition-all ${className}`}
      >
        <Heart size={16} className={inList ? "fill-[#8C3A3A] text-[#8C3A3A]" : "text-stone-700"} strokeWidth={1.5} />
      </button>
    );
  }
  return (
    <button
      onClick={toggle}
      data-testid={`watchlist-toggle-${auctionId}`}
      disabled={busy}
      className={`inline-flex items-center gap-2 text-xs uppercase tracking-widest font-semibold border px-6 py-3 transition-colors ${inList ? "bg-[#8C3A3A] text-stone-50 border-[#8C3A3A]" : "border-stone-900 hover:bg-stone-900 hover:text-stone-50"} ${className}`}
    >
      <Heart size={14} className={inList ? "fill-current" : ""} />
      {inList ? t("Nei preferiti") : t("Aggiungi ai preferiti")}
    </button>
  );
}
